import React from 'react';
import Hero from '../components/Hero';
import heroImage from '../assets/hero.jpg';
import donkeyLogo from '../assets/donkey_logo.png';
import './Billiards.css';

const Billiards: React.FC = () => {
  return (
    <div className="billiards-page">
      <Hero
        title="Billiards"
        image={heroImage}
        height="40vh"
        useClipPath={true}
        chevronLogo={donkeyLogo}
      />

      <main className="page-content text-center">
        <div className="container">
          <h2 style={{ fontFamily: 'Damion, cursive', fontSize: '3rem', marginTop: '2rem' }}>
            Coming Soon
          </h2>
          <p style={{ fontSize: '1.2rem', color: '#666', marginTop: '1rem' }}>
            We're working on something exciting for our billiards section. Stay tuned!
          </p>
        </div>
      </main>
    </div>
  );
};

export default Billiards; 